import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Diagnostico";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/diagnostico/")({
  head: () =>
    pageHead({
      title: "Diagnóstico gratuito: seu perfil de alimentação na Austrália | Clara Camille",
      description:
        "Em 3 minutos descubra o seu perfil de alimentação na Austrália e do que você precisa para comer bem aqui, com a nutricionista brasileira Clara Camille. Grátis.",
      path: "/diagnostico",
      ogTitle: "Descubra o seu perfil de alimentação na Austrália",
      ogDescription: "Diagnóstico gratuito de 3 minutos com uma nutricionista brasileira na Austrália.",
    }),
  component: Page,
});
